"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper/Paper.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shadows = {
  none: 'none',
  softShadowUp: '0px -5px 15px rgba(0, 0, 0, 0.1)',
  softShadowCenter: '0px 0px 20px rgba(0, 0, 0, 0.14)',
  softShadowDown: '0px -5px 15px rgba(0, 0, 0, 0.1)',
  hardShadowUp: '0px -2px 4px rgba(0, 0, 0, 0.5)',
  hardShadowCenter: '0px 0px 6px rgba(0, 0, 0, 0.95)',
  hardShadowDown: '0px 2px 4px rgba(0, 0, 0, 0.5)'
};

var getBorderStyles = function getBorderStyles(variant, color) {
  var borderColor = _Colors.default[color];
  if (variant === 'regular') return 'none';

  if (variant === 'outlined') {
    return "1px solid ".concat(borderColor);
  }

  return "1px dashed ".concat(borderColor);
};

var useStyle = (0, _makeStyles.default)({
  root: function root(_ref) {
    var width = _ref.width,
        height = _ref.height,
        padding = _ref.padding,
        margin = _ref.margin,
        boxShadow = _ref.boxShadow,
        variant = _ref.variant,
        color = _ref.color;
    return {
      width: width,
      height: height,
      padding: padding,
      margin: margin,
      boxShadow: variant === 'regular' ? shadows[boxShadow] : shadows.none,
      border: getBorderStyles(variant, color),
      boxSizing: 'border-box'
    };
  }
});

var Paper = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
      margin = props.margin,
      width = props.width,
      height = props.height,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? '24px 32px' : _props$padding,
      _props$boxShadow = props.boxShadow,
      boxShadow = _props$boxShadow === void 0 ? 'softShadowDown' : _props$boxShadow,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      _props$color = props.color,
      color = _props$color === void 0 ? 'lightGrey' : _props$color,
      square = props.square,
      children = props.children;

  var _useStyle = useStyle({
    margin: margin,
    padding: padding,
    height: height,
    width: width,
    boxShadow: boxShadow,
    variant: variant,
    color: color
  }),
      root = _useStyle.root;

  return /*#__PURE__*/_react.default.createElement(_Paper.default, {
    ref: ref,
    className: className,
    classes: {
      root: root
    },
    square: square,
    "data-testid": props['date-testid']
  }, children);
});

var _default = Paper;
exports.default = _default;